import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { IonInfiniteScroll, IonSearchbar, Platform } from '@ionic/angular';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { TableColumn } from '../../../core/models/table-column';
import { MatTableDataSource } from '@angular/material/table';
import { TextKeys } from '../../../core/i18n/text-keys';
import { Location } from '@angular/common';
import { MaterialCatalogueItemsService } from '../../../core/state-mangement/entities/material-catalogue-items/material-catalogue-items.service';
import { MaterialCatalogueItemsQuery } from '../../../core/state-mangement/entities/material-catalogue-items/material-catalogue-items.query';
import {
  debounceTime,
  distinctUntilChanged,
  map,
  startWith,
  tap,
} from 'rxjs/operators';
import { OrderListItemModel } from '../../../core/models/order/order-list-item.model';
import { SettingsQuery } from '../../../core/state-mangement/settings/settings.query';
import { ExpensesCatalogueFilterOptionsModel } from '../../../core/models/expenses-catalogue/expenses-catalogue-filter-options.model';
import { MaterialCatalogueListItem } from 'src/app/core/models/client-models';

@Component({
  selector: 'app-material-catalog-list',
  templateUrl: './material-catalog-list.component.html',
  styleUrls: ['./material-catalog-list.component.scss'],
})
export class MaterialCatalogListComponent implements OnInit, OnDestroy {
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  @ViewChild(IonSearchbar, { static: true }) searchBar: IonSearchbar;

  @Output() onCancel = new EventEmitter();

  searchFilter$ = new BehaviorSubject<string>('');
  materialCatalogueList$: Observable<MaterialCatalogueListItem[]>;
  filterOptions$: Observable<ExpensesCatalogueFilterOptionsModel>;
  tableColumns$: Observable<TableColumn[]>;
  isLoading$: Observable<boolean>;
  dataSource: MatTableDataSource<MaterialCatalogueListItem>;
  selectedIndex: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  currentOrder: OrderListItemModel;
  lastPage$ = this.materialCatalogueItemsQuery.lastPage$;
  showTable$: Observable<boolean> = this.platform.resize.pipe(
    startWith(
      this.platform.width() > this.settingsQuery.getValue()?.smallScreenWidth
    ),
    map(
      () =>
        this.platform.width() > this.settingsQuery.getValue()?.smallScreenWidth
    )
  );
  texts = TextKeys;

  private subscriptions = new Subscription();

  constructor(
    public materialCatalogueItemsService: MaterialCatalogueItemsService,
    private location: Location,
    private platform: Platform,
    private settingsQuery: SettingsQuery,
    private materialCatalogueItemsQuery: MaterialCatalogueItemsQuery
  ) {}

  ngOnInit() {
    this.materialCatalogueItemsService.clearCache();
    this.materialCatalogueList$ = this.materialCatalogueItemsQuery.selectAll();
    this.subscriptions.add(
      this.materialCatalogueList$.subscribe((value) => {
        this.dataSource = new MatTableDataSource<MaterialCatalogueListItem>(
          value
        );
      })
    );
    this.tableColumns$ = this.materialCatalogueItemsQuery.columns$;

    this.registerInfiniteScrollEnd();
    this.registerFilterValueChange();

    this.filterOptions$ = this.materialCatalogueItemsQuery.filterOptions$;
    this.materialCatalogueItemsService.getNextPage();
    setTimeout(() => this.searchBar.setFocus(), 500);
  }

  ngOnDestroy() {
    this.materialCatalogueItemsService.clearFilter();
    this.subscriptions.unsubscribe();
  }

  onHover(index: number) {
    this.selectedIndex.next(index);
  }

  onCancelClick() {
    this.materialCatalogueItemsService.selected(undefined);
    this.materialCatalogueItemsService.clearFilter();
    this.location.back();
  }

  loadData(event: Event) {
    this.materialCatalogueItemsService.getNextPage();
    (event.target as unknown as IonInfiniteScroll).complete();
  }

  onClick(material: MaterialCatalogueListItem) {
    this.materialCatalogueItemsService.selected(material);
    this.location.back();
  }

  onEnter() {
    this.materialCatalogueItemsService.selected(
      this.dataSource.data[this.selectedIndex.getValue()]
    );
    this.location.back();
  }

  private registerFilterValueChange() {
    this.subscriptions.add(
      this.searchBar.ionInput
        .pipe(
          debounceTime(100),
          map((event) => (event.target as HTMLInputElement).value),
          distinctUntilChanged(),
          tap((value) => {
            this.selectedIndex.next(0);
            this.materialCatalogueItemsService.filterValueChange(value);
          })
        )
        .subscribe()
    );
  }

  private registerInfiniteScrollEnd() {
    this.subscriptions.add(
      this.materialCatalogueItemsQuery.lastPage$
        .pipe(
          tap((value) => {
            if (value) {
              this.infiniteScroll.disabled;
            }
          })
        )
        .subscribe()
    );
  }
}
